export const printDate = (value, includeTime = false) => {
  if (!value) return 'Not recorded';
  const date = new Date(/^\d{4}-\d{2}-\d{2}$/.test(value) ? `${value}T12:00:00` : value);
  if (Number.isNaN(date.getTime())) return String(value);
  return new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric',
    ...(includeTime ? { hour: 'numeric', minute: '2-digit', timeZoneName: 'short' } : {}) }).format(date);
};
export const printStatus = (status) => ({ not_started: 'Not started', in_progress: 'In progress',
  on_hold: 'On hold', completed: 'Completed' }[status] || status);
export const printNumber = (value) => new Intl.NumberFormat('en-US', { maximumFractionDigits: 3 }).format(value);

// CSS string escaping for a generated margin-box identifier; never interpreted as HTML.
export const printCssString = (value) => `"${String(value).replace(/[\u0000-\u001f\u007f]/g, ' ').replace(/\\/g, '\\\\').replace(/"/g, '\\"')}"`;